import React, { useState } from "react";
import {
    Alert,
    Avatar,
    Box,
    Button,
    Paper,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const Login = () => {
    /* -------------------- local state -------------------- */
    const [auth, setAuth] = useState({ email: "", password: "" });
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState({ message: "", status: "" });

    /* -------------------- nav + responsivity -------------- */
    const navigate = useNavigate();
    const theme = useTheme();
    const downSm = useMediaQuery(theme.breakpoints.down("sm")); // <600 px

    /* -------------------- auto-redirect ------------------- */
    // useEffect(() => {
        // if (localStorage.getItem("user")) navigate("/");
    // }, []);

    /* -------------------- handlers ------------------------ */
    const handleChange = (e) =>
        setAuth({ ...auth, [e.target.name]: e.target.value });

    const handleLogin = () => {
        if (!auth.email.trim() || !auth.password.trim()) {
            flashAlert("Please enter both email and password.", "ERR");
            return;
        }

        axios
            .post("https://music-endpoint.onrender.com/auth/login", auth)
            .then(({ data }) => {
                flashAlert(data.message, data.status);
                if (data.status === "OK") {
                    setTimeout(() => {
                        // localStorage.setItem("token", data.token);
                        // localStorage.setItem("user", JSON.stringify(data.user));
                        navigate("/");
                    }, 1500);
                }
            })
            .catch((err) =>
                flashAlert(err.response?.data?.message || "Login failed", "ERR")
            );
    };

    const flashAlert = (message, status) => {
        setAlertMessage({ message, status });
        setShowAlert(true);
        setTimeout(() => setShowAlert(false), 3000);
    };

    /* -------------------- render -------------------------- */
    return (
        <Box
            sx={{
                minHeight: "100vh",
                bgcolor: "#f0f0f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                px: 2, // side padding on mobile
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    width: { xs: "100%", sm: 420, md: 400 }, // 100 % on phones
                    p: { xs: 3, sm: 4 },
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    alignItems: "center",
                }}
            >
                <Avatar sx={{ bgcolor: "black", width: 56, height: 56 }}>
                    <AccountCircleOutlinedIcon fontSize="large" />
                </Avatar>

                {showAlert && (
                    <Alert
                        severity={alertMessage.status === "OK" ? "success" : "error"}
                        sx={{ width: "100%" }}
                    >
                        {alertMessage.message}
                    </Alert>
                )}

                <Typography variant={downSm ? "h5" : "h4"}>Log in</Typography>

                <TextField
                    label="Email"
                    variant="outlined"
                    name="email"
                    value={auth.email}
                    onChange={handleChange}
                    fullWidth
                />

                <TextField
                    label="Password"
                    variant="outlined"
                    type="password"
                    name="password"
                    value={auth.password}
                    onChange={handleChange}
                    fullWidth
                />

                <Box sx={{ width: "100%", textAlign: "right" }}>
                    <Link to="/forget-password">Forgot password?</Link>
                </Box>

                <Button variant="contained" fullWidth onClick={handleLogin}>
                    Login
                </Button>

                <Typography variant="body2">
                    Don’t have an account? <Link to="/SignUp">Sign up</Link>
                </Typography>
            </Paper>
        </Box>
    );
};

export default Login;
